import { restRequest } from "./RequestHelper"

export default (type, url) => restRequest(type, url)